/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core/";
import { useContext, useState } from "react";
import { config as url } from "../../../common/config";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import FormOnEditService from "./FormOnEditService";
import FormOnService from "./FormOnService";
import TableOnServices from "./TableOnServices";

const Service = () => {
	const BaseUrl = `${url.services}`;
	const fetchData = useContext(FetchDataContext);
	const { getDataTables, addData, updateData, deleteData, tableRef } =
		fetchData;
	const [state, setState] = useState({
		openAdd: false,
		pageSize: 5,
	});
	const { openAdd, pageSize } = state;
	const [openEdit, setOpenEdit] = useState(false);
	const [data, setData] = useState();

	const handleOpenCloseFormAdd = () => {
		setState({ ...state, openAdd: !openAdd });
	};

	const handleOpenCloseFormEdit = (params) => {
		setOpenEdit(!openEdit);
		setData(params);
	};
	const fetchAPI = async (action, data) => {
		let result;
		if (action === "add")
			result = await addData(
				`${BaseUrl}/add_layanan`,
				data,
				handleOpenCloseFormAdd
			);
		if (action === "edit")
			result = await updateData(
				`${BaseUrl}/edit_layanan?id=${data.id}`,
				data,
				handleOpenCloseFormEdit
			);

		if (action === "delete")
			result = await deleteData(
				`${BaseUrl}/delete_layanan?id=${data.id}`,
				data.nama,
				{
					status: false,
				}
			);
		return result;
	};

	return (
		<Grid direction="column" alignItems="center">
			<TableOnServices
				BaseUrl={BaseUrl}
				getDataTables={getDataTables}
				fetchAPI={fetchAPI}
				pageSize={pageSize}
				tableRef={tableRef}
				modalAdd={handleOpenCloseFormAdd}
				modalEdit={handleOpenCloseFormEdit}
			/>
			<FormOnService
				open={openAdd}
				handleClose={handleOpenCloseFormAdd}
				fetchAPI={fetchAPI}
			/>
			<FormOnEditService
				open={openEdit}
				editData={data}
				handleClose={handleOpenCloseFormEdit}
				fetchAPI={fetchAPI}
			/>
		</Grid>
	);
};
export default Service;
